<template>
    <div class="toggle-content p-0">
        <div class="bottom-packet-row" v-if="index === 0">
            <div class="packet-info tracking-info" v-if="statuses.delivered.includes(tracking.original_status)">
                <div class="packet-info-column">
                    <h4 class="packet-info-title">{{ $helper.trans('Date_of_delivery') }}:</h4>
                    <span>{{ moment(parcel.datetime).format('YYYY MM DD, HH:mm') }}</span>
                </div>
                <div class="packet-info-column">
                    <h4 class="packet-info-title">{{ $helper.trans('Delivered_to') }}:</h4>
                    <span>{{ parcel.address }}</span>
                </div>
                <div class="packet-info-column">
                    <h4 class="packet-info-title">{{ $helper.trans('Service') }}:</h4>
                    <span>{{ parcel.service }}</span>
                </div>
                <div class="packet-info-column">
                    <h4 class="packet-info-title">{{ $helper.trans('Recipient') }}:</h4>
                    <span>{{ parcel.receiver }}</span>
                </div>
                <div v-if="parcel.signature" class="packet-info-column">
                    <h4 class="packet-info-title">{{ $helper.trans('Signature') }}:</h4>
                    <button type="button" class="btn btn-yellow btn-packet radius-4" data-toggle="modal" data-target="#signature_modal">
                        {{ $helper.trans('View_signature') }}
                    </button>
                </div>
            </div>
            <activity-component
                :parcel="parcel"
            ></activity-component>
        </div>

        <div v-else>
            <div class="my-2" style="color: #242424; font-weight: bold; font-size: 22px; line-height: 30px;" v-if="index === 1">
                {{ $helper.trans('Other_tracking_packages') }}
            </div>
            <status-header-component
                :delivered="statuses.delivered.includes(tracking.original_status)"
                :trackingNumber="trackingNumber"
                :trackingStatus="tracking.status"
                :classes="(index === 1) ? '' : 'mt-4'"
                :extendActivity="true"
                :parcel="parcel"
            ></status-header-component>
        </div>

        <div class="modal fade" id="signature_modal" tabindex="-1" role="dialog" aria-labelledby="signature_modal_title" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $helper.trans('Signature') }}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <img :src="`data:image/png;base64,${parcel.signature}`">
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-yellow btn-packet radius-4" data-dismiss="modal">{{ $helper.trans('Close') }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        trackingNumber: {
            type: String,
            required: true,
        },
        tracking: {
            type: Object,
            required: true,
        },
        parcel: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },
        statuses: {
            type: Object,
            required: true,
        },
    },
}
</script>
